import styled from 'styled-components';
import { layout, brandColors, colorUtils } from '@prisjakt/ui-base';

const { spacing025, spacing050 } = layout.measurements;

export const ExpertRating = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Text = styled.span`
  margin-right: ${spacing025};
  font-weight: 600;
  font-size: ${layout.measurements.fontSizeMedium};
  line-height: 1;
`;

export const Badge = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${spacing025} ${spacing050};
  background: ${colorUtils.setRgbaAlpha(brandColors.expert, 1)};
  border-radius: 20px;
  justify-self: start;
  font-weight: 600;
  color: ${p => p.theme.colors.base0};
  line-height: 1;

  svg {
    margin-right: ${layout.measurements.spacing025};
  }
`;

export const Stars = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RatingText = styled.span`
  font-weight: 700;
  font-size: ${layout.measurements.fontSizeMedium};
  margin-left: ${layout.measurements.spacing025};
`;
